import React from 'react';

const SectionHeader = ({ title, subtitle }) => (
  <div style={{ marginBottom: '3rem', textAlign: 'center' }}>
    <h2 className="section-title">{title}</h2>
    {subtitle && <p className="section-subtitle">{subtitle}</p>}
  </div>
);

export default SectionHeader;
